export default [

    {
        path: 'dashboard',
        meta: { modulo: 'dashboard', menu: false },
        components: { conteudo: () => import('@/aplicacao/modulos/dashboard/_Master') },
        children: [...require('@/aplicacao/modulos/dashboard/_configuracoes/rotas').default],
    },

    {
        path: 'dashboard-o',
        meta: { modulo: 'dashboard-o', menu: false },
        components: { conteudo: () => import('@/aplicacao/modulos/dashboard-o/_Master') },
        children: [...require('@/aplicacao/modulos/dashboard-o/_configuracoes/rotas').default],
    },

    {
        path: 'usuarios',
        meta: { modulo: 'usuarios', menu: false },
        components: { conteudo: () => import('@/aplicacao/modulos/usuarios/_Master') },
        children: [...require('@/aplicacao/modulos/usuarios/_configuracoes/rotas').default],
    },

    {
        path: 'ajuda',
        meta: { modulo: 'ajuda', menu: true, },
        components: {
            menu: () => import('@/aplicacao/modulos/ajuda/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/ajuda/_Master'),
        },
        children: [...require('@/aplicacao/modulos/ajuda/_configuracoes/rotas').default],
    },

    {
        path: 'encarte-exclusivo-impresso',
        meta: { modulo: 'encartes', menu: true, },
        components: {
            menu: () => import('@/aplicacao/modulos/encartes/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/encartes/_Master'),
        },
        children: [...require('@/aplicacao/modulos/encartes/_configuracoes/rotas').default],
    },

    {
        path: 'arte-para-encarte-exclusivo',
        meta: { modulo: 'encartes-virtuais', menu: true, },
        components: {
            menu: () => import('@/aplicacao/modulos/encartes-virtuais/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/encartes-virtuais/_Master'),
        },
        children: [...require('@/aplicacao/modulos/encartes-virtuais/_configuracoes/rotas').default],
    },

    {
        path: 'arte-para-tabloide-e-box',
        meta: { modulo: 'box', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/box/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/box/_Master'),
        },
        children: [...require('@/aplicacao/modulos/box/_configuracoes/rotas').default],
    },

    {
        path: 'arte-para-redes-sociais',
        meta: { modulo: 'midias-sociais', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/midias-sociais/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/midias-sociais/_Master'),
        },
        children: [...require('@/aplicacao/modulos/midias-sociais/_configuracoes/rotas').default],
    },

    {
        path: 'artes-digitais',
        meta: { modulo: 'artes-digitais', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/artes-digitais/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/artes-digitais/_Master'),
        },
        children: [...require('@/aplicacao/modulos/artes-digitais/_configuracoes/rotas').default],
    },

    {
        path: 'vendas-whatsapp',
        meta: { modulo: 'acoes-whatsapp', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/acoes-whatsapp/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/acoes-whatsapp/_Master'),
        },
        children: [...require('@/aplicacao/modulos/acoes-whatsapp/_configuracoes/rotas').default],
    },

    {
        path: 'vendas-whats-midias',
        meta: { modulo: 'vendas-whats-midias', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/vendas-whats-midias/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/vendas-whats-midias/_Master'),
        },
        children: [...require('@/aplicacao/modulos/vendas-whats-midias/_configuracoes/rotas').default],
    },

    {
        path: 'boas-praticas',
        meta: { modulo: 'boas-praticas', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/boas-praticas/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/boas-praticas/_Master'),
        },
        children: [...require('@/aplicacao/modulos/boas-praticas/_configuracoes/rotas').default],
    },

    {
        path: 'fichas-cadastrais',
        meta: { modulo: 'fichas-cadastrais', menu: false },
        components: { conteudo: () => import('@/aplicacao/modulos/fichas-cadastrais/_Master') },
        children: [...require('@/aplicacao/modulos/fichas-cadastrais/_configuracoes/rotas').default],
    },

    {
        path: 'banco-de-produtos',
        meta: { modulo: 'banco-de-midias', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/banco-de-midias/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/banco-de-midias/_Master'),
        },
        children: [...require('@/aplicacao/modulos/banco-de-midias/_configuracoes/rotas').default],
    },

    {
        path: 'material-de-apoio',
        meta: { modulo: 'material-de-apoio', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/material-de-apoio/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/material-de-apoio/_Master'),
        },
        children: [...require('@/aplicacao/modulos/material-de-apoio/_configuracoes/rotas').default],
    },

    {
        path: 'ppc',
        meta: { modulo: 'ppc', menu: false },
        components: { conteudo: () => import('@/aplicacao/modulos/ppc/_Master') },
        children: [...require('@/aplicacao/modulos/ppc/_configuracoes/rotas').default],
    },

    {
        path: 'feedback',
        meta: { modulo: 'feedback', menu: false },
        components: { conteudo: () => import('@/aplicacao/modulos/feedback/_Master') },
        children: [...require('@/aplicacao/modulos/feedback/_configuracoes/rotas').default],
    },

    {
        path: 'relatorios',
        meta: { modulo: 'relatorios', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/relatorios/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/relatorios/_Master'),
        },
        children: [...require('@/aplicacao/modulos/relatorios/_configuracoes/rotas').default],
    },

    {
        path: 'comunicados',
        meta: { modulo: 'comunicados', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/comunicados/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/comunicados/_Master'),
        },
        children: [...require('@/aplicacao/modulos/comunicados/_configuracoes/rotas').default],
    },

    {
        path: 'cartas-de-planejamento',
        meta: { modulo: 'cartas-de-planejamento', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/cartas-de-planejamento/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/cartas-de-planejamento/_Master'),
        },
        children: [...require('@/aplicacao/modulos/cartas-de-planejamento/_configuracoes/rotas').default],
    },

    {
        path: 'pesquisa-de-campo',
        meta: { modulo: 'pesquisa-de-campo', menu: true, },
        components: {
            menu: () => import('@/aplicacao/modulos/pesquisa-de-campo/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/pesquisa-de-campo/_Master'),
        },
        children: [...require('@/aplicacao/modulos/pesquisa-de-campo/_configuracoes/rotas').default],
    },

    {
        path: 'logistica',
        meta: { modulo: 'logistica', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/logistica/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/logistica/_Master'),
        },
        children: [...require('@/aplicacao/modulos/logistica/_configuracoes/rotas').default],
    },

    {
        path: 'ferramentas',
        meta: { modulo: 'ferramentas', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/ferramentas/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/ferramentas/_Master'),
        },
        children: [...require('@/aplicacao/modulos/ferramentas/_configuracoes/rotas').default],
    },

    {
        path: 'administracao',
        meta: { modulo: 'administracao', menu: true },
        components: {
            menu: () => import('@/aplicacao/modulos/administracao/_Menu'),
            conteudo: () => import('@/aplicacao/modulos/administracao/_Master'),
        },
        children: [...require('@/aplicacao/modulos/administracao/_configuracoes/rotas').default],
    },

]
